import m from 'mithril';
import SimpananTab from './components/SimpananTab.js';
import PinjamanTab from './components/PinjamanTab.js';
import { getTerm } from '../js/nomenclature.js';

// Main Produk Component
const Produk = {
    oninit: function () {
        this.activeTab = 'simpanan'; // Default to simpanan tab
        this.tabContainer = null; // Will hold reference to the container DOM element
    },

    switchToSimpanan: function () {
        this.activeTab = 'simpanan';
        if (this.tabContainer) {
            m.mount(this.tabContainer, SimpananTab);
        }
        m.redraw();
    },

    switchToPinjaman: function () {
        this.activeTab = 'pinjaman';
        if (this.tabContainer) {
            m.mount(this.tabContainer, PinjamanTab);
        }
        m.redraw();
    },

    oncreate: function (vnode) {
        // Store reference to the container and mount initial component
        this.tabContainer = vnode.dom.querySelector('#tab-content');
        if (this.activeTab === 'simpanan') {
            m.mount(this.tabContainer, SimpananTab);
        } else {
            m.mount(this.tabContainer, PinjamanTab);
        }
    },

    view: function () {
        return m('div', { class: 'p-4 sm:p-6' }, [
            m('div', { class: 'mb-6' }, [
                m('div', { class: 'flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-2' }, [
                    m('div', [
                        m('h1', { class: 'text-2xl font-bold text-gray-800 dark:text-white' }, 'Manajemen Produk'),
                        m('p', { class: 'text-gray-600 dark:text-gray-400 mt-1' }, 'Kelola produk simpanan dan pinjaman')
                    ]),
                    m('div', { class: 'flex items-center space-x-2' }, [
                        m('div', { class: 'hidden sm:block w-px h-6 bg-gray-200 dark:bg-gray-700' }),
                        m('div', { class: 'flex items-center text-sm text-gray-500 dark:text-gray-400' }, [
                            m('i', { class: 'ri-information-line mr-1' }),
                            'Pilih tab untuk melihat produk'
                        ])
                    ])
                ])
            ]),

            // Tab navigation with improved styling
            m('div', { class: 'mb-6' }, [
                m('div', { class: 'border-b border-gray-200 dark:border-gray-700' }, [
                    m('nav', { class: '-mb-px flex space-x-6 md:space-x-8' }, [
                        m('button', {
                            class: `py-3 px-1 border-b-2 font-medium text-sm flex items-center transition-colors duration-200 ${this.activeTab === 'simpanan'
                                    ? 'border-orange-500 text-orange-600 dark:text-orange-400'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                                }`,
                            onclick: () => this.switchToSimpanan()
                        }, [
                            m('i', { class: 'ri-bank-line mr-2' }),
                            'Simpanan',
                            m('span', { class: 'ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-orange-500 rounded-full' },
                                this.activeTab === 'simpanan' ? 'Aktif' : '')
                        ]),
                        m('button', {
                            class: `py-3 px-1 border-b-2 font-medium text-sm flex items-center transition-colors duration-200 ${this.activeTab === 'pinjaman'
                                    ? 'border-orange-500 text-orange-600 dark:text-orange-400'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                                }`,
                            onclick: () => this.switchToPinjaman()
                        }, [
                            m('i', { class: 'ri-money-dollar-circle-line mr-2' }),
                            'Pinjaman',
                            m('span', { class: 'ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-orange-500 rounded-full' },
                                this.activeTab === 'pinjaman' ? 'Aktif' : '')
                        ])
                    ])
                ]),

                // Tab description
                m('div', { class: 'mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800/50' }, [
                    m('div', { class: 'flex items-start' }, [
                        m('i', { class: 'ri-information-line text-blue-500 dark:text-blue-400 text-lg mr-2 mt-0.5' }),
                        m('div', [
                            m('p', { class: 'text-sm font-medium text-blue-800 dark:text-blue-200' },
                                this.activeTab === 'simpanan'
                                    ? 'Produk Simpanan'
                                    : 'Produk Pinjaman'),
                            m('p', { class: 'text-sm text-blue-700 dark:text-blue-300 mt-1' },
                                this.activeTab === 'simpanan'
                                    ? 'Kelola berbagai jenis produk simpanan yang ditawarkan oleh unit simpan pinjam.'
                                    : `Kelola berbagai jenis produk pinjaman dengan fleksibilitas tenor (hari/minggu/bulan/tahun) dan frekuensi ${getTerm('fields.interest', 'bunga')} (harian/mingguan/bulanan/triwulanan/tahunan/musiman).`)
                        ])
                    ])
                ])
            ]),

            // Tab content container for mounting
            m('div', {
                id: 'tab-content',
                class: 'transition-opacity duration-300 ease-in-out',
                style: { opacity: 1 }
            })
        ]);
    }
};

export default Produk;